import * as d3 from 'd3';
import Vue from 'vue';

import kernelDensityEstimator from './kernelDensityEstimator';
import kernelEpanechnikov from './kernelEpanechnikov';


const CalculatePreviewHighlightDensity = (val) => {
  
  // This function expects a 1-dim array of samples (so this is for one time slice only)
  // This function returns the density (an array of 2-dim arrays; x/y pairs, y being the probability density)
  // Note: This is analogous to the calculation in plotDetailPopUpGraph.js
  // This is where the highlight is calculated as well

  let minDataPoint = d3.min(val);
  let maxDataPoint = d3.max(val);

  // console.log('globalHighlightArray', Vue.prototype.$globalHighlightArray)

  // Filter by highlight range
  // We reduce the array to those data points that correspond to data points...
  // ...in the original array that were within range
  let reducedValueArray = [];
  for (let i = 0; i < val.length; i++) {
    if(Vue.prototype.$globalHighlightArray[i] == 1){
      reducedValueArray.push(val[i]);
    }
  }


  // console.log(reducedValueArray)

  // add the x Axis
  // Is is defined here to have x.ticks available below
  // It gets redefined again below
  let x = d3.scaleLinear()
    .domain([minDataPoint,maxDataPoint])
    .range([0, 140]);

  
  let kde = kernelDensityEstimator(kernelEpanechnikov((maxDataPoint-minDataPoint)/15), x.ticks(40));
  let density = kde(reducedValueArray);

  // console.log('The highlight density has this many values: ', density.length)

  let xDensity = density.map(function(elt) { return elt[0]; });
  let yDensity = density.map(function(elt) { return elt[1]; });

  let xDensityMax = d3.max(xDensity);
  let xDensityMin = d3.min(xDensity);

  // This adds more elements at the beginning of the array
  density.unshift([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.01,0])
  density.unshift([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.2,0])

  // This add more elements at the end of the array
  density.push([xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.01,0])
  density.push([xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.2,0])

  // console.log('density at this stage', density)
  
  // Define y axis
  // Range uses the height as first parameter
  // The data domain for the y axis is from 0 to max of the density (since we have a probability)
  let y = d3.scaleLinear()
    .range([100, 0])
    .domain([0, d3.max(yDensity)]);
  
  // Re-define x axis
  // Width is the width of the preview container
  x = d3.scaleLinear()
    .domain([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.2, xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.2])
    .range([0, 140]);
  
  // Pascal: I don't know what this is supposed to to. It is also used in CalculatePreviewDensity
  // Without this, the distribution is not shown in the preview
  for (let i = 0; i < density.length; i++) {
    density[i] = [x(density[i][0]), y(density[i][1])];
  }

  // console.log('highlight density', density)

  /* 
    Conversion of highlight boundaries
    ----------------------------------------
    We also convert the upperBound and lowerBound into the domain range here.
    They are stored as actual values but need to be represented as x/y values of the SVG based on its size.
    This way, the VueDistPreview receives the right values immediately.
  */
  
  let lowerBound = Vue.prototype.$globalSharedData.lastSliderPositionLowerBoundAsString;
  let upperBound = Vue.prototype.$globalSharedData.lastSliderPositionUpperBoundAsString;

  if (lowerBound){
    // Only attempt to convert if we actually have a value
    lowerBound = x(parseFloat(lowerBound));
  }

  if (upperBound){
    // Only attempt to convert if we actually have a value
    upperBound = x(parseFloat(upperBound));
  }

  // Determine lowest / highest x Value in density (in D3 domain)
  let minX = x(xDensityMin);
  let maxX = x(xDensityMax);

  let returnObj = {
    density: density,
    yDensity: yDensity,
    lowerBound: lowerBound,
    upperBound: upperBound,
    minX: minX,
    maxX: maxX
  }

  return returnObj;
}

export default CalculatePreviewHighlightDensity
